/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface ExerciseToolDto
 */
export interface ExerciseToolDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof ExerciseToolDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof ExerciseToolDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof ExerciseToolDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof ExerciseToolDto
     */
    deleted: string | null;

    /**
     * @type {string}
     * @memberof ExerciseToolDto
     */
    type: ExerciseToolDtoTypeEnum;

    /**
     * @type {boolean}
     * @memberof ExerciseToolDto
     */
    asset: boolean;

    /**
     * @type {JoinEntityDto}
     * @memberof ExerciseToolDto
     */
    exercise: JoinEntityDto;

    /**
     * @type {JoinEntityDto}
     * @memberof ExerciseToolDto
     */
    client?: JoinEntityDto;
}

/**
 * @export
 * @enum {string}
 */
export enum ExerciseToolDtoTypeEnum {
    CHAIR = 'CHAIR',
    MAT = 'MAT',
    TABLE = 'TABLE',
    BALL = 'BALL',
    BOX = 'BOX',
    ROD = 'ROD',
    MINIROD = 'MINI_ROD',
    WEIGHT = 'WEIGHT'
}

